// ** Reducers Imports
import layout from "./layout"
import navbar from "./navbar"
import appUsers from "../store"

const rootReducer = { navbar, layout, appUsers }

export default rootReducer
